import React, {useState, useEffect }from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../assets/images/ft_logo.png'
import Google from '../../assets/images/googleplay.png'
import Appstore from '../../assets/images/appstorebtn.png'
import { newsletterApi } from '../../services/api';
import logger from '../../utils/logger';

function Main() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(null); // success | error
    const [loading, setLoading] = useState(false);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      setStatus(null);
      setLoading(true);
      try {
        const res = await newsletterApi.subscribeNewsletter(email);
        // Check response message for already subscribed
        if (res.message && res.message.includes('Already')) {
            setStatus('already');
        } else {
            setStatus('success');
        }
        setEmail('');
      } catch (err) {
        logger.error('Failed to subscribe to newsletter', err);
        setStatus('error');
      } finally {
        setLoading(false);
      }
    };
    
    return (
        <>
            <footer className="white_text" data-aos="fade-in" data-aos-duration={1500}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="logo_side">
                                <div className="logo">
                                    <Link to="/">
                                        <img src={Logo} alt="Logo" />
                                    </Link>
                                </div>
                                <div className="news_letter">
                                    <h3>Abonează-te la newsletter</h3>
                                    <p>Află primul când apar noutăți și profită de ofertele noastre</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input  type="email" className="form-control" placeholder="Adresa ta de email..." value={email} onChange={(e) => setEmail(e.target.value)} required/>
                                            <button className="btn" type="submit" disabled={loading}>
                                                <i className={`icofont-${loading ? 'spinner-alt-2' : 'paper-plane'}`} />
                                            </button>
                                        </div>
                                        {status === 'success' && <p className="note text-success">Verifică emailul pentru a confirma abonarea.</p>}
                                        {status === 'error' && <p className="note text-danger">A apărut o eroare. Încearcă din nou.</p>}
                                        {status === 'already' && <p className="note text-warning">Ești deja abonat la newsletter.</p>}
                                        <p className="note">
                                        Prin apăsarea butonului „Trimite”, ești de acord să primești un mesaj.
                                        </p>
                                    </form>
                                </div>
                                <ul className="contact_info">
                                    <li>
                                        <Link to="mailto:contact@lumo.ro">contact@lumo.ro</Link>
                                    </li>
                                    <li>
                                        <Link to="tel:+40712345678">+40 712 345 678</Link>
                                    </li>
                                </ul>
                                <ul className="social_media">
                                    <li>
                                        <Link to="https://redirect.lumo.ro/social-facebook">
                                            <i className="icofont-facebook" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://redirect.lumo.ro/social-linkedin">
                                            <i className="icofont-linkedin" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://redirect.lumo.ro/social-instagram">
                                            <i className="icofont-instagram" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://redirect.lumo.ro/social-whatsapp">
                                            <i className="icofont-whatsapp" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="download_side">
                                <h3>Descarcă aplicația</h3>
                                <p>Aplicația este acum disponibilă pe Android și iOS</p>
                                <ul className="app_btn">
                                    <li>
                                        <Link to="https://redirect.lumo.ro/download-lumo-app-android">
                                            <img className="blue_img" src={Google} alt="image" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://redirect.lumo.ro/download-lumo-app-ios">
                                            <img className="blue_img" src={Appstore} alt="image" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_bottom">
                    <div className="container">
                        <div className="ft_inner">
                            <div className="copy_text">
                                <p>LUMO © Copyrights 2025. All rights reserved.</p>
                            </div>
                            <ul className="links">
                                <li>
                                    <Link to="/">Acasă</Link>
                                </li>
                                <li>
                                    <Link to="/business">Business</Link>
                                </li>
                                <li>
                                    <Link to="/about">Despre noi</Link>
                                </li>
                                <li>
                                    <Link to="/blog">Blog</Link>
                                </li>
                                <li>
                                    <Link to="/contact">Contact</Link>
                                </li>
                            </ul>
                            <div className="design_by">
                                <p>
                                    <Link to="https://redirect.lumo.ro/become-lumo-partner" target="blank">
                                        Devin-o partener LUMO
                                    </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Main